  import React, { useRef, useState, useEffect } from "react";
  import { AgGridReact } from "ag-grid-react";
  import * as XLSX from "xlsx";
  import { toast, ToastContainer } from "react-toastify";
  import "react-toastify/dist/ReactToastify.css";
  import "ag-grid-community/styles/ag-grid.css";
  import "ag-grid-community/styles/ag-theme-alpine.css";
  import { Delete, getData } from "../../../API";
  import { useLocation, useNavigate } from "react-router-dom";

  function ApprovalPendingReports() {
    const [rowData, setRowData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
    const [filteredData, setFilteredData] = useState([]);
    const [filters, setFilters] = useState({ zoneId: '', wardNo: '' });
    const [allWardData, setAllWardData] = useState([]);
    const [allZoneData, setAllZoneData] = useState([]);
    const [search, setSearch] = useState("");
    const gridRef = useRef();
    const location = useLocation();
    const navigate = useNavigate();
    const fileInputRef = useRef(null);

    const defaultColDef = {
      sortable: true,
      resizable: true,
      flex: 1,
      suppressSizeToFit: true,
      minWidth: 180,
    };
    
    const columnDefs = [
      {
        headerName: "S.No",
        field: "sNo",
        maxWidth: 80,
        valueGetter: (params) => params.node.rowIndex + 1,
        headerClass: "grid-header",
        filter: false,
      },
      {
        field: "establishmentType",
        headerName: "Type of Establishment",
        headerClass: "grid-header",
      },
      {
        field: "ownerName",
        headerName: "Owner Name",
        headerClass: "grid-header",
      },
      {
        field: "ownerContactNo",
        headerName: "Owner Contact No",
        headerClass: "grid-header",
      },
      {
        field: "createdDate",
        headerName: "Surveyor Date",
        valueFormatter: params => new Date(params.value).toLocaleDateString(),
        headerClass: "grid-header",
      },
      {
        headerName: "Property House No",
        field: "houseNo",
        // valueFormatter: (params) =>
        //   params.value ? new Date(params.value).toLocaleDateString() : "",
        headerClass: "grid-header",
      },
      {
        headerName: "Address",
        field: "address",
        headerClass: "grid-header",
      },
      {
        field: "status",
        headerName: "Verified",
        headerClass: "grid-header",
        cellRenderer: (params) => {
          const status = params.value;
      
          let statusLabel;
          let statusClass;
      
          switch (status) {
            case 0:
              statusLabel = "Unverified";
              statusClass = "text-danger";
              break;
            case 1:
              statusLabel = "Verified";
              statusClass = "text-success";
              break;
            case 2:
              statusLabel = "Waiting for Approval";
              statusClass = "text-warning";
              break;
            default:
              statusLabel = "Unknown";
              statusClass = "text-muted";
          }
      
          return (
            <div className="d-flex justify-content-around">
              <span className={statusClass}>{statusLabel}</span>
            </div>
          );
        },
      },
      {
        field: "action",
        headerName: "Action",
        width: 100,
        cellRenderer: (params) => {
          const primaryId = params.data.sdid;
          return (
            <div className="d-flex justify-content-around mt-2">
              <button
                onClick={() => {
                  navigate(`/waiting-for-approval/${primaryId}`, {
                    state: { details: params.data },
                  });
                }}
                className="btn btn-sm rounded-3"
                style={{
                  boxShadow:
                    "0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)",
                  color: "white",
                  background: "#9CA3AF",
                  fontWeight: 600,
                }}
              >
                Edit
              </button>
              <button
              className="btn btn-sm rounded-3 "
              style={{
                boxShadow: '0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)',
                background: "red",
                fontWeight: 600,
                color:"white"
               
              }}
              onClick={()=>handleDelete(params.data)}
            >
              
                Delete
             
            </button>
            </div>
          );
        },
        headerClass: "grid-header",
        cellClass: "no-right-border",
        suppressMenu: true,
        sortable: false,
      },
    ];
    useEffect(() => {
        if (filters.zoneId) {
          getWardType(filters.zoneId);
        } else {
          setAllWardData([]);
        }
      }, [filters.zoneId]);
    const getWardType = async (zoneId) => {
        try {
          const res = await getData(`SurveyMasters/GetAllWards?zoneId=${zoneId}`);
          // const response = await res.json();
          setAllWardData(res.data);
        } catch (error) {
          console.error('Error fetching ward data:', error);
          setAllWardData([]);
        }
      };
    
      const getZoneType = async () => {
        try {
          const res = await getData('SurveyMasters/UCCZoneMasters');
          // const response = await res.json();
          setAllZoneData(res.data);
        } catch (error) {
          console.error('Error fetching zone data:', error);
          setAllZoneData([]);
        }
      };
     
      const handleFilterChange = (e) => {
      const { name, value } = e.target;
      setFilters((prevFilters) => ({
        ...prevFilters,
        [name]: value,
      }));
    };
    const handleZoneChange = (e) => {
      const { name, value } = e.target;
      setFilters(prevFilters => ({
        ...prevFilters,
        zoneId: value,
        wardNo: ''
      }));
    };

    const handleSearch = () => {
      fetchData(filters);
    };
     const handleDelete=async(data)=>
      {
        const url=`SurveyDetails/DeleteFilteredSurveys/${data.sdid}`
       
       try{
        const res=await Delete(url);
        fetchData(filters);
        toast.success(res)
       }catch(error){
         toast.error("error",error)
       }
    
      }
    
    const buildQueryParams = (filters) => {
        const queryParams = new URLSearchParams();
        Object.keys(filters).forEach(key => {
          if (filters[key]) {
            queryParams.append(key, filters[key]);
          }
        });
        return queryParams.toString();
      };
    // Fetch data from API
    const fetchData = async (filters) => {
      setIsLoading(true);
      try {
        const updatedFilters = { ...filters};
        const queryParams = buildQueryParams(updatedFilters);
        const response = await getData(`SurveyDetails/SurveysForWaitingForApproval?${queryParams}`);
        setFilteredData(Array.isArray(response) ? response : []);
        // Check response structure and properly set the row data
        if (Array.isArray(response)) {
          setRowData(response);
        } else if (Array.isArray(response.data)) {
          setRowData(response.data);
        } else if (response && typeof response === "object") {
          setRowData([response]);
        } else {
          setRowData([]);
        }
      } catch (error) {
        setError("Failed to fetch data. Please try again later.");
        toast.error("Error loading data");
      } finally {
        setIsLoading(false);
      }
    };

    // useEffect(() => {
    //   fetchData(filters);
    // }, []);
       useEffect(() => {
        getZoneType();
        fetchData(filters);
      }, []);
    // Handle Excel download
    const downloadExcel = () => {
      if (!rowData || rowData.length === 0) {
        toast.warning("No data available to download");
        return;
      }

      // Prepare headers - including all the requested fields
      const tableHeaders = [
        "S.No",
        "EstablishmentTypeId",
        "EstablishmentType",
        "OwnerShipTypeId",
        "OwnerShipType",
        "ServiceStatusId",
        "ServiceStatusName",
        "TagId",
        "UUId",
        "MuncipalRegNo",
        "RegistrationStartDate",
        "RegistrationEndDate",
        "HouseNo",
        "OwnerName",
        "OwnerContactNo",
        "EmailId",
        "MinWasteQty",
        "CommercialTypeId",
        "CommercialType",
        "RateTypeDisplay",
        "Rate",
        "TenantName",
        "TenantContactNo",
        "NoOfMembers",
        "Address",
        "LatLng",
        "Landmark",
        "Remarks",
        "ZoneId",
        "ZoneNo",
        "WardNo",
        "IsCommercial",
        "RoomAttached",
        "IsActive",
        "CreatedDate",
        "CreatedBy",
        "ModifiedDate",
        "ModifiedBy",
        "RateCategoryId",
        "RateCategoryName",
        "RateSubCategoryId",
        "RateSubCategoryName",
        "ExtraArea",
        "UserId",
        "MunicipalCommercialNo",
        "FixedValue",
        "SyncGuid",
        "ParentGuid",
        "ImageUrl",
        "Verified",
      ];

      // Prepare data for Excel - map all the requested fields
      const tableData = rowData.map((item, index) => ({
        "S.No": index + 1,
        EstablishmentTypeId: item.establishmentTypeId || "",
        EstablishmentType: item.establishmentType || "",
        OwnerShipTypeId: item.ownerShipTypeId || "",
        OwnerShipType: item.ownerShipType || "",
        ServiceStatusId: item.serviceStatusId || "",
        ServiceStatusName: item.serviceStatusName || "",
        TagId: item.tagId || "",
        UUId: item.uuId || "",
        MuncipalRegNo: item.muncipalRegNo || "",
        RegistrationStartDate: item.registrationStartDate
          ? new Date(item.registrationStartDate).toLocaleDateString()
          : "",
        RegistrationEndDate: item.registrationEndDate
          ? new Date(item.registrationEndDate).toLocaleDateString()
          : "",
        HouseNo: item.houseNo || "",
        OwnerName: item.ownerName || "",
        OwnerContactNo: item.ownerContactNo || "",
        EmailId: item.emailId || "",
        MinWasteQty: item.minWasteQty || "",
        CommercialTypeId: item.commercialTypeId || "",
        CommercialType: item.commercialType || "",
        RateTypeDisplay: item.rateTypeDisplay || "",
        Rate: item.rate || "",
        TenantName: item.tenantName || "",
        TenantContactNo: item.tenantContactNo || "",
        NoOfMembers: item.noOfMembers || "",
        Address: item.address || "",
        LatLng: item.latLng || "",
        Landmark: item.landmark || "",
        Remarks: item.remarks || "",
        ZoneId: item.zoneId || "",
        ZoneNo: item.zoneNo || "",
        WardNo: item.wardNo || "",
        IsCommercial: item.isCommercial ? "Yes" : "No",
        RoomAttached: item.roomAttached ? "Yes" : "No",
        IsActive: item.isActive ? "Yes" : "No",
        CreatedDate: item.createdDate
          ? new Date(item.createdDate).toLocaleDateString()
          : "",
        CreatedBy: item.createdBy || "",
        ModifiedDate: item.modifiedDate
          ? new Date(item.modifiedDate).toLocaleDateString()
          : "",
        ModifiedBy: item.modifiedBy || "",
        RateCategoryId: item.rateCategoryId || "",
        RateCategoryName: item.rateCategoryName || "",
        RateSubCategoryId: item.rateSubCategoryId || "",
        RateSubCategoryName: item.rateSubCategoryName || "",
        ExtraArea: item.extraArea || "",
        UserId: item.userId || "",
        MunicipalCommercialNo: item.municipalCommercialNo || "",
        FixedValue: item.fixedValue || "",
        SyncGuid: item.syncGuid || "",
        ParentGuid: item.parentGuid || "",
        ImageUrl: item.imageUrl || "",
        Verified: item.isUpdated ? "Verified" : "UnVerified",
      }));

      // Create worksheet
      const worksheet = XLSX.utils.json_to_sheet(tableData);
      XLSX.utils.sheet_add_aoa(worksheet, [tableHeaders], { origin: "A1" });

      // Create workbook
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Pending Approvals");

      // Generate file
      XLSX.writeFile(workbook, "PendingApprovals.xlsx");
    };

    // Handle grid ready event
    const onGridReady = (params) => {
      params.api.sizeColumnsToFit();
    };

    const handleButtonClick = () => {
      fileInputRef.current.click();
    };

    const handleBulkUpload = async (event) => {
      if (!event || !event.target) {
        console.error("Event or event target is undefined");
        return;
      }
      const file = event.target.files[0];
      if (file) {
        const formData = new FormData();
        formData.append("file", file);
        const token = localStorage.getItem("token");
        const BASE_URL = process.env.REACT_APP_API_BASEURL;

        try {
          const res = await fetch(BASE_URL + `SurveyDetails/BulkUpload`, {
            method: "POST",
            headers: {
              Authorization: `Bearer ${token}`,
            },
            body: formData,
          });

          if (res.status === 200) {
            const result = await res.json();
            toast.success("File uploaded successfully", {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
            });
            fetchData(filters); // Refresh data after successful upload
          } else {
            const errorResponse = await res.text();
            toast.error(errorResponse, {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
            });
          }
        } catch (error) {
          toast.error("An error occurred while uploading the file", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
          });
        }
      } else {
        toast.error("Please select a file to upload", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
        });
      }
    };

    return (
      <div>
        <main className="page-content content">
          <div className="container-fluid p-0">
            <div className="row align-items-center mb-3">
              <div className="col-md-6">
                <h1 className="title_pages">Waiting For Approval</h1>
              </div>
            </div>
            <div className='filters'>
              <div className='row align-items-end'>
                <div className="col-md-12">
                  <div className="row align-items-end">
                    <div className="col-md-3">
                      <div className='form-group'>
                        <label>Zone</label>
                        <select type="select" className='form-select' name="zoneId" onChange={handleZoneChange} style={{ backgroundColor: "#D9D9D9", boxShadow: '0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)' }} value={filters.zoneId}>
                          <option value="">Select</option>
                          {allZoneData.map((zone) => (
                            <option key={zone.uccZoneId} value={zone.uccZoneId}>{zone.zoneName}</option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className='form-group'>
                        <label>Ward</label>
                        <select type="select" className='form-select' name="wardNo" onChange={handleFilterChange} style={{ backgroundColor: "#D9D9D9", boxShadow: '0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)' }} value={filters.wardNo}>
                          <option value="">Select</option>
                          {allWardData.map((ward) => (
                            <option key={ward.wardId} value={ward.wardNo}>{`${ward.wardNo} - ${ward.wardName}`}</option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <div className="col-md-3 mx-auto mb-3">
                      <label for="search-input" class="form-label">
                        Search
                      </label>
                      <div class="position-relative">
                        <input
                          type="search"
                          id="search-input"
                          class="search-button px-3"
                          placeholder="Search..."
                          value={search}
                          onChange={(e) => setSearch(e.target.value)}
                        />
                      </div>
                    </div>
                    <div className="col-md-3 mb-3 text-start d-flex gap-2">
                      <button
                        className="btn px-4"
                        onClick={handleSearch}
                        style={{
                          background: "#a7252ced",
                          border: "none",
                          color: "white",
                          boxShadow:
                            "0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)",
                        }}
                      >
                        SEARCH
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="d-flex  mt-1 mb-3">
              <button
                className="btn"
                onClick={downloadExcel}
                disabled={!rowData || rowData.length === 0}
                style={{
                  background: "#9CA3AF",
                  color: "white",
                  marginRight:"5px",
                  boxShadow:
                    "0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)",
                }}
              >
                Excel <i className="fa-solid fa-download ms-1"></i>
              </button>
               <button
              className="btn ml-3"
              style={{
                background: "#9CA3AF",
                color: "white",
                boxShadow:
                  "0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)",
                
              }}
              onClick={() => navigate("/waiting-for-apporval-deleted-report")}
            >
            Deleted WFA Records <i class="fa-solid fa-trash"></i>
            </button>

              {/* Hidden file input for bulk upload */}
              <input
                type="file"
                ref={fileInputRef}
                onChange={handleBulkUpload}
                accept=".xlsx,.xls"
                style={{ display: "none" }}
              />
            </div>

            <div className="card shadow">
              <div className="card-body">
                {error && (
                  <div className="alert alert-danger" role="alert">
                    {error}
                  </div>
                )}
                  <div style={{ position: 'relative' }}>
                  {isLoading && (
                    <div className="loader-overlay">
                    <div className="spinner" />
                    </div>
                  )}
                  <div className="table-responsive">
                    <div
                      className="ag-theme-alpine"
                      style={{ height: 600, width: "100%", margin: "auto" }}
                    >
                      <AgGridReact
                        ref={gridRef}
                        domLayout="autoHeight"
                        defaultColDef={defaultColDef}
                        onGridReady={onGridReady}
                        rowData={isLoading ? [] : filteredData}
                        columnDefs={columnDefs}
                        pagination={true}
                        paginationPageSize={10}
                        rowHeight={45}
                        quickFilterText={search}
                        paginationPageSizeSelector={[10, 20, 50, 100]}
                        // overlayLoadingTemplate={
                        //   '<span class="ag-overlay-loading-center">Loading...</span>'
                        // }
                        overlayNoRowsTemplate={
                        !isLoading
                          ? '<span class="ag-overlay-loading-center">No data available</span>'
                          : undefined // ✅ Don't render overlay at all when loading
                      }
                      />
                    </div>
                  </div>
                  </div>
              </div>
            </div>
          </div>
          <ToastContainer position="top-right" autoClose={3000} />
        </main>
      </div>
    );
  }

  export default ApprovalPendingReports;
